import React, { PropsWithChildren } from 'react'

interface ConditionalProps {
    conditional: boolean
}

const Conditional = ({ conditional, children }: PropsWithChildren<ConditionalProps>) => {
    // Conditional
    if (conditional) {
        return <>{children}</>
    }
    return null
}

export default Conditional
